module.exports = __webpack_public_path__ + "img/룬나이트.117c97fb.png";